export function getPricingURL(instanceId) {
  return 'https://origem.digital' + instanceId + '/'
}
